import Title from '../components/dashContent/Title'
import { Outlet } from 'react-router-dom';

const Projects = () => {
  
  return (
    <div className='m-1'>
      <Title text="Projectos" />
      <Outlet>
        
      </Outlet>
    </div>
  )
}

export default Projects